import React, { useState, useEffect } from 'react'
import { Box, Text, Heading } from 'grommet'
import { Refresh, View } from 'grommet-icons'
import { useDispatch, useSelector } from 'react-redux'
import TooltipButton from '../Button/TooltipButton'
import styled from 'styled-components'
import Input from './input'
import {
  setChoices,
  setResultsArray,
  setTypeOption,
  setAutoSpinMerge,
  setInputMethod,
  setBoardIndex,
  showTurntable,
} from '../../redux/rng/actions'
import ResultType from './resultType'
import { device } from '../../theme/device'
import { useHideInput } from '../../contextHook/hideInput'
import InputMethod from './inputMethod'
import FormulaInput from './formulaInput'
import { displayModifyTitleModal } from '../../redux/modal/actions'
import HideShuffleTitleButton from '../Button/HideShuffleTitleButton'
import DigitInput from './digitInput'
import { usePersistValue } from '../../hook/usePersistValue'
import InputLength from '../Common/InputLength'

const Container = styled(Box)`
  border-radius: 2rem;
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  min-height: 0px;
  padding: 1.3rem 2rem 2rem;
  width: 50rem;
  background-color: ${props => props.theme.global.colors.baseBackground};
  height: ${props => props.containerHeight};
  @media ${device.medium} {
    /* border-radius: 1.5rem; */
    padding: 1.3rem 0.8rem 2rem;
    /* height: 32rem; */
  }
  /* width: 50rem;
  padding: 1rem 0;
  @media ${device.medium} {
    height: ${props => props.containerHeight};
  } */
`

const IconBox = styled(Box)`
  position: relative;
  &::after {
    content: '';
    position: absolute;
    border-top: ${props =>
      props.active ? '0px solid #aaa' : '2px solid #aaa'};
    width: 18px;
    transform: rotate(45deg);
    transform-origin: 8px 2px;
  }
`

// const RightTopBox = styled(Box)`
//   /* height: 35rem;
//   @media ${device.medium} {
//     height: 25rem;
//   } */
// `

const ReactRNG = () => {
  const {
    choices,
    digitNumber,
    autoSpinMerge,
    digitRanges,
    boardIndex,
    resultsArray,
  } = useSelector(state => state.rng)
  const { value: typeOption } = usePersistValue(
    state => state.rng.typeOption,
    0,
  )
  const { value: inputMethod } = usePersistValue(
    state => state.rng.inputMethod,
    'By Range',
  )
  const [rangeInputInit, setRangeInputInit] = useState(false)
  const { setHiding } = useHideInput()
  const dispatch = useDispatch()

  useEffect(() => {
    if (typeOption > 0 && digitNumber !== resultsArray.length) {
      // second condition to prevent all reset to null when load file
      numberDigitChanged(digitNumber)
    }
  }, [typeOption])

  const shuffle = () => {
    let arra1 = choices.slice(0)
    let ctr = arra1.length
    let temp
    let index

    // While there are elements in the array
    while (ctr > 0) {
      // Pick a random index
      index = Math.floor(Math.random() * ctr)
      // Decrease ctr by 1
      ctr--
      // And swap the last element with it
      temp = arra1[ctr]
      arra1[ctr] = arra1[index]
      arra1[index] = temp
    }
    dispatch(setChoices(arra1.slice(0)))
  }

  const numberDigitChanged = digit => {
    dispatch(setBoardIndex(0))
    const tempArray = []
    for (let i = 0; i < digit; i++) {
      tempArray.push(null)
    }
    dispatch(setResultsArray(tempArray)) //init results array
  }

  let containerHeight = '53rem'
  // if (inputMethod === 'By Formula') containerHeight = '50.9rem'
  if (typeOption > 0) containerHeight = 'auto'

  return (
    <Container justify="start" containerHeight={containerHeight}>
      <Box align="center" gap=".7rem" direction="row" justify="between">
        <Box direction="row" align="center" gap=".6rem">
          <Heading level={3} alignSelf="center" margin={{ vertical: '0px' }}>
            INPUTS
          </Heading>
          {typeOption === 0 && choices.length > 0 && (
            <InputLength length={choices.length} />
          )}
        </Box>
        {typeOption === 0 ? (
          <HideShuffleTitleButton setHiding={setHiding} shuffle={shuffle} />
        ) : (
          <Box
            direction="row"
            gap=".5rem"
            alignSelf="center"
            // height="13.7rem"
            align="center"
          >
            <TooltipButton
              icon={<View color="iconDarkLight" />}
              clicked={() => {
                setHiding(true)
              }}
              message="Hide"
              position="top"
              color=""
              padding=".8rem"
            />
            <TooltipButton
              icon={<Refresh color="iconDarkLight" />}
              clicked={() => {
                if (typeOption !== 0) {
                  const tempArray = []
                  for (let i = 0; i < digitNumber; i++) {
                    tempArray.push(null)
                  }
                  dispatch(setResultsArray(tempArray))
                }
              }}
              message="Reset"
              position="right"
              padding=".8rem"
            />
            <TooltipButton
              icon={
                <IconBox
                  height="1.8rem"
                  width="1.8rem"
                  align="center"
                  justify="center"
                  active={autoSpinMerge}
                >
                  <Text
                    color={autoSpinMerge ? 'secondary' : 'disabled'}
                    size="1.8rem"
                  >
                    A
                  </Text>
                </IconBox>
              }
              clicked={() => {
                dispatch(setAutoSpinMerge(!autoSpinMerge))
              }}
              message={`${
                autoSpinMerge ? 'Disable' : 'Enable'
              } Auto Spin and Merge`}
              position="left"
              color={autoSpinMerge ? 'secondary' : 'disabled'}
            />

            <TooltipButton
              icon={
                <Box
                  width="1.8rem"
                  height="1.8rem"
                  align="center"
                  justify="center"
                >
                  <Text color="secondary" size="1.8rem">
                    T
                  </Text>
                </Box>
              }
              clicked={() => {
                dispatch(displayModifyTitleModal(true))
              }}
              message="Modify Title & Desc."
              position="right"
              color="secondary"
            />
          </Box>
        )}
      </Box>
      <Box gap="1.5rem" flex={true}>
        <ResultType
          typeOption={typeOption}
          setTypeOption={index => {
            dispatch(setTypeOption(index))
            numberDigitChanged(digitNumber)
            dispatch(showTurntable(null))
          }}
        />
        {typeOption === 0 ? (
          <Box gap="1.5rem" flex={true}>
            <InputMethod
              inputMethod={inputMethod}
              setInputMethod={method => dispatch(setInputMethod(method))}
            />
            {inputMethod === 'By Range' ? (
              <Input
                rangeInputInit={rangeInputInit}
                setInitDone={() => setRangeInputInit(true)}
              />
            ) : (
              <FormulaInput />
            )}
          </Box>
        ) : (
          <Box gap="1.5rem" justify="center">
            <DigitInput
              digitNumber={digitNumber}
              numberDigitChanged={numberDigitChanged}
              digitRanges={digitRanges}
              boardIndex={boardIndex}
            />
          </Box>
        )}
      </Box>
    </Container>
  )
}

export default ReactRNG
